package org.ksdfv.thelema.kxjs

import org.ksdfv.thelema.utils.ILog

class JsLog: ILog {
    override var infoEnabled: Boolean = true
    override var debugEnabled: Boolean = true
    override var errorEnabled: Boolean = true

    override fun info(message: String, exception: Throwable?, tag: String) {
        console.log(message)
    }

    override fun debug(message: String, exception: Throwable?, tag: String) {
        console.log(message)
    }

    override fun error(message: String, exception: Throwable?, tag: String) {
        console.error(message)
    }
}